export default {"src":"/_next/static/media/icon-jet-1-suites.0c62b948.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};